<div id="resultsGroup" class="container">
    <div class="header row">
        <div class="navigation col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div
                class="row no-gutters filters-wrapper"
                [ngStyle]="{ 'background-color': colorCode }"
            >
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-9 left-filter">
                    <span class="filter-by">Filter by</span>
                    <span><app-filter-by-grade></app-filter-by-grade></span>
                    <span><app-filter-by-type></app-filter-by-type></span>
                    <span *ngIf="hasFilter()"><app-filter-clear></app-filter-clear></span>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-3">
                    <app-rank-by class="right-filter"></app-rank-by>
                </div>
            </div>
        </div>
    </div>
    <div class="browsing-group selenium" [ngClass]="group.htmlID" *ngFor="let group of groups">
        <div
            inViewport
            [inViewportOptions]="inViewportConfig"
            class="browsing-group-inner"
            #category
            *ngIf="!group.hide"
            (inViewportAction)="loadNextGroup(group, groups, $event)"
        >
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-ms-12 col-lg-12">
                    <h2 class="group-title col-xs-12" #categoryTitle [attr.id]="group.htmlID">
                        <span class="icon">
                            <app-icon [type]="group.mediaType"></app-icon>
                        </span>
                        <span class="media-type-name">{{ group.title | pluralizeMediaType }}</span>
                        <span class="media-type-count">({{ group.count }})</span>
                    </h2>
                </div>
            </div>
            <div class="browsing-items row">
                <div
                    class="browsing-item col-auto"
                    *ngFor="let learningObject of group.results; let i = index"
                >
                    <app-collection-browse-card
                        class="mb-6"
                        *ngIf="learningObject.isCollection"
                        [learningObject]="learningObject"
                        [gtmPrefix]="gtmPrefix"
                        [gtmDataCardNumber]="i + 1"
                    ></app-collection-browse-card>
                    <app-resource-search-card
                        class="mb-6"
                        *ngIf="
                            !learningObject.isCollection && innerWidth <= cardTypeChangeBreakpoint
                        "
                        [learningObject]="learningObject"
                        [gtmPrefix]="'gtm-results-browse-card'"
                        [gtmDataCardNumber]="i + 1"
                    ></app-resource-search-card>
                    <app-resource-browse-card
                        *ngIf="
                            !learningObject.isCollection && innerWidth > cardTypeChangeBreakpoint
                        "
                        [learningObject]="learningObject"
                        [gtmPrefix]="gtmPrefix"
                        [gtmDataCardNumber]="i + 1"
                    ></app-resource-browse-card>
                </div>
            </div>
            <div class="browsing-more row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button
                        class="gtm-browse-subjects-see-more btn btn-primary view-more"
                        [attr.data-gtmlabel]="group.title | pluralizeMediaType"
                        *ngIf="group.next"
                        (click)="getMoreResults(group)"
                    >
                        + See more {{ group.title | pluralizeMediaType | lowercase }}
                    </button>
                    <button
                        class="btn btn-transparent collapse-more"
                        *ngIf="group.results.length > 10"
                        (click)="collapseResults(group); scrollTo(categoryTitle)"
                    >
                        Collapse
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="hasNoResults" class="no-results">
        <span>Uh oh...</span>
        <div>
            There are no more results for the filters you have selected. You can try broadening your
            filters to see more results again.
        </div>
    </div>
</div>
